module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "frontMatterPage",
    attrs: {
      "id": "fm01"
    }
  }, [_c('div', {
    staticClass: "chapterHead"
  }, [_c('h2', {
    staticClass: "chapterTitle"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("The 411 on "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("HG 1-2-3")]), _vm._v("…")])])]), _vm._v(" "), _c('div', {
    staticClass: "chapterBody"
  }, [_c('p', {
    staticClass: "chapterOpenerText",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("Welcome to "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Hungry Girl 1-2-3: The Easiest, Most Delicious, Guilt-Free Recipes on the Planet")]), _vm._v(". This is the THIRD HG cookbook and I LOVE it. I’m pretty sure you will, too. Why? Well, like our other books, it’s PACKED with great recipes for fantastic-tasting foods that are low in calories and fat grams. But this book is different, in some ways, and quite possibly the best of the bunch. (I hope we always keep getting better and better!) Here are the key things that make this book super-amazing and SO EASY to use…and, um, some other relevant stuff as well!")]), _vm._v(" "), _c('p', {
    staticClass: "chapterHeadC"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("1. There are more fresh fruits, veggies, and lean protein in the recipes than ever before.")])]), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("We listened, and they’re all here.")]), _vm._v(" "), _c('p', {
    staticClass: "chapterHeadC"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("2. Fast and easy recipes.")])]), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("The name says it all. It’s not like Hungry Girl recipes are ever THAT complicated—you know this. But the recipes in this book are crazy-simple to make. Like, easier than any other recipes anywhere. Really. There are entire chapters devoted to microwavable recipes, recipes with four ingredients or less, and recipes that require no cooking whatsoever!")]), _vm._v(" "), _c('p', {
    staticClass: "chapterHeadC"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("3. So many meals!!!")])]), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("In "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("200 Under 200")]), _vm._v(", we loaded you up on snacks. This time around, there’s more of a focus on entrées. DELICIOUS ones.")]), _vm._v(" "), _c('p', {
    staticClass: "chapterHeadC"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("4. New recipe format.")])]), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("We decided it was time to make the leap. Now the ingredients are listed in the order they’re used, and each recipe starts off by listing some kitchen essentials along with the approximate prep and cook times. There are also lots of useful tips, plus notes on recipes that call for a common ingredient or two, so opened products don’t have to go to waste. Soooooo helpful!")]), _vm._v(" "), _c('p', {
    staticClass: "chapterHeadC"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("5. Your crock-pot prayers have been answered.")])]), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("You asked for more, and now you’ve got ’em. There’s an entire chapter devoted to crock-pot recipes. Party time!")]), _vm._v(" "), _c('p', {
    staticClass: "chapterHeadC"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("6. Foil-pack recipes GALORE.")])]), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("Wrapping stuff in foil and baking it couldn’t be easier. Our foil-pack recipes have become so popular, I thought it would be great to include a full chapter of them…so I did. There are even easy-to-follow instructions for adapting these recipes to be made on the grill. Yay!")]), _vm._v(" "), _c('p', {
    staticClass: "chapterHeadC"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("7. Couples.")])]), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("Our two-ingredient recipes have become so beloved, I wanted to carve out an entire section of the book for them. And that’s what I did. There are more than 60 food duos here!")]), _vm._v(" "), _c('p', {
    staticClass: "chapterHeadC"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("8. Photos and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("POINTS")]), _c('sup', [_vm._v("®")]), _vm._v(".")])]), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("As always, photos for every single recipe in this book along with Weight Watchers "), _c('span', {
    staticClass: "bold"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("POINTS")])]), _c('sup', [_vm._v("®")]), _vm._v(" values"), _c('sup', [_c('span', {
    staticClass: "footnoteRef"
  }, [_c('span', {
    attrs: {
      "href": "#/footnote1",
      "id": "footnote1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")])])]), _vm._v(" can be found at "), _c('span', {
    staticClass: "xrefURL"
  }, [_c('a', {
    attrs: {
      "href": "http://hungry-girl.com/book",
      "target": "_blank"
    }
  }, [_vm._v("hungry-girl.com/book")])]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "spaceBreak"
  }), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("Happy chewing!!!!")]), _vm._v(" "), _c('p', {
    staticClass: "spaceBreak"
  }), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Lisa")]), _vm._v(" :)")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-def03060","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/hungrygirl123_fm01.vue
// module id = 84
// module chunks = 0